import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public enviroment: string;
  public templateVersion: string;
  public templateName: string;

  constructor() { 
    this.enviroment = environment.title;
    this.templateVersion = environment.templateVersion;
    this.templateName = environment.templateName;
  }

  ngOnInit() {
    
  }

}
